import { useTranslation } from "react-i18next";

import { IconCalendarCheck02, IconFile05 } from "@pentabd/icons";
import { Button, Header } from "@pentabd/ui";

interface ReportModalType {
  openReportModal: () => void;
}

const AttendancePageHeader = ({ openReportModal }: ReportModalType) => {
  const { t } = useTranslation();

  const breadcrumbs = [
    {
      icon: <IconCalendarCheck02 fill="dark" size="20" />,
    },
    {
      label: t("ATTENDANCE.LABEL"),
    },
  ];

  const actions = [
    <Button
      fill="fill"
      size="sm"
      type="primary"
      htmlType="button"
      onClick={openReportModal}
    >
      <IconFile05 size="20" fill="white" />
      {t("ATTENDANCE.GENERATE_REPORT_BUTTON")}
    </Button>,
  ];

  const headerText = {
    header: t("ATTENDANCE.HEADING"),
    subHeader: t("ATTENDANCE.HEADER_DESCRIPTION"),
  };

  return (
    <Header
      breadcrumbs={breadcrumbs}
      headerText={headerText}
      actions={actions}
      noBorder
    />
  );
};

export default AttendancePageHeader;
